export default __webpack_public_path__ + "static/5-205bcc57407c9166c7bd18ab03dfc33c.jpg";